export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What protocol and port does SMTP use?",
    "description": "TCP port 25."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "What protocol and port does FTP send data from for the data channel?",
    "description": "TCP port 20."
  },
  {
    "id": 3,
    "topic_id": 1,
    "title": "What layer 4 protocol supports reliable connections?",
    "description": "Transport Control Protocol (TCP)."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "What protocol is used for logical addressing of the network?",
    "description": "Internet Protocol (IP)."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "What protocol do ping and traceroute use for testing connectivity?",
    "description": "Internet Control Message Protocol (ICMP)."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "What is the IPv6 DAD protocol used for?",
    "description": "Duplicate address detection (DAD)."
  },
  {
    "id": 7,
    "topic_id": 5,
    "title": "How many bytes are in a UDP header?",
    "description": "8 bytes total = 16 bits for the source port, 16 bits for destination port, 16 bits for the length, and a 16-bit checksum. Each of these header fields is 2 bytes long (16-bits)."
  },
  {
    "id": 8,
    "topic_id": 5,
    "title": "How does the TCP protocol support sequencing and acknowledgment of segments?",
    "description": "Sliding windows."
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "What transport layer is connectionless and provides faster transport of datagrams?",
    "description": "User Datagram Protocol (UDP)."
  },
  {
    "id": 10,
    "topic_id": 2,
    "title": "What protocol is used for Microsoft Active Directory object and attribute searches?",
    "description": "Lightweight Directory Access Protocol (LDAP)."
  },
  {
    "id": 11,
    "topic_id": 4,
    "title": "What layer of the OSI provides conversion of data?",
    "description": "Presentation layer."
  },
  {
    "id": 12,
    "topic_id": 2,
    "title": "What layer of the OSI is responsible for preparing data to be transmitted on a medium?",
    "description": "Data Link layer."
  },
  {
    "id": 13,
    "topic_id": 1,
    "title": "What layer of the OSI is responsible for the flow control of data?",
    "description": "Transport layer."
  },
  {
    "id": 14,
    "topic_id": 3,
    "title": "What layer of the OSI is synonymous with dialog control?",
    "description": "Session layer."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "How do applications bind to the transports layer?",
    "description": "With TCP and UDP port numbers."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "When an application creates an outbound connection, what is the value of the source port number?",
    "description": "Dynamically allocated over 1024."
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "How does the transport layer communicate with the network layer and vice versa?",
    "description": "Protocol numbers such as ICMP 1, TCP 6, UDP 17, and so on."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "How many bytes is a MAC address?",
    "description": "6 bytes or 48 bits normally written as a hexadecimal expression such as 0D-54-0D-C0-10-52."
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "What bit in the MAC address indicates the MAC address has been statically set?",
    "description": "When the Global/Local (GL) bit is set to 1, it is locally governed (statically set)."
  },
  {
    "id": 20,
    "topic_id": 1,
    "title": "How many bits is the organizationally unique identifier (OUI) in the MAC address?",
    "description": "The first 24 bits (3 bytes) of the MAC address is the OUI governed by the IEEE."
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "What layer 2 contention method does Ethernet use to manage collisions?",
    "description": "Carrier Sense Multiple Access/Collision Detection (CSMA/CD)."
  },
  {
    "id": 22,
    "topic_id": 1,
    "title": "What layer 2 contention method does 802.11 wireless use to allow clients to communicate?",
    "description": "Carrier Sense Multiple Access/Collision Avoidance (CSMA/CA)."
  },
  {
    "id": 23,
    "topic_id": 2,
    "title": "What is the protocol data unit (PDU) for data at the application layer?",
    "description": "User datagrams."
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What is the default maximum transmission unit (MTU) size for Ethernet?",
    "description": "1,500 bytes, sometimes also referred to as 1,518 bytes if the header is included."
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "What is the destination MAC address for broadcasts?",
    "description": "The destination MAC address is always FF-FF-FF-FF-FF-FF for broadcast frames."
  },
  {
    "id": 26,
    "topic_id": 3,
    "title": "What protocol helps map IP addresses to MAC addresses?",
    "description": "Address Resolution Protocol (ARP)."
  },
  {
    "id": 27,
    "topic_id": 2,
    "title": "What protocol assists in creating multicast groups on switches?",
    "description": "Internet Group Management Protocol (IGMP)."
  },
  {
    "id": 28,
    "topic_id": 2,
    "title": "What is the IEEE trunking protocol used for trunking switches?",
    "description": "802.1Q trunking protocol."
  },
  {
    "id": 29,
    "topic_id": 3,
    "title": "What type of switch port removes the VLAN information before forwarding the frame?",
    "description": "Untagging port, sometimes called an access port."
  },
  {
    "id": 30,
    "topic_id": 2,
    "title": "What protocol is used to allow the redundancy of switch paths by avoiding switching loops?",
    "description": "Spanning Tree Protocol (STP) 802.1D."
  },
  {
    "id": 31,
    "topic_id": 2,
    "title": "A valid Media Access Control (MAC) address is how many bytes long?",
    "description": "6."
  },
  {
    "id": 32,
    "topic_id": 4,
    "title": "What well-known port does Trivial File Transfer Protocol (TFTP) use?",
    "description": "69."
  },
  {
    "id": 33,
    "topic_id": 1,
    "title": "In which OSI layer does a bridge operate?",
    "description": "Data Link."
  },
  {
    "id": 34,
    "topic_id": 3,
    "title": "An IT specialist is going to implement a packet filter on a network for Internet connections. What port must they allow through the firewall for users to connect to the web?",
    "description": "80/443."
  },
  {
    "id": 35,
    "topic_id": 3,
    "title": "Which network attack drives CPU and memory up in an attempt to deny users access?",
    "description": "DoS, DDoS."
  },
  {
    "id": 36,
    "topic_id": 3,
    "title": "True/False: Virtual local area networks (VLANs) create broadcast domains.",
    "description": "True."
  },
  {
    "id": 37,
    "topic_id": 3,
    "title": "You notice that a user is sending usernames and passwords in clear text. What network monitoring utility was used?",
    "description": "Packet sniffer."
  },
  {
    "id": 38,
    "topic_id": 3,
    "title": "You have a remote office with very few users. Which WAN technology would be sufficient?",
    "description": "Cable modem or DSL."
  },
  {
    "id": 39,
    "topic_id": 3,
    "title": "What versions of SNMP are susceptible to a packet sniffer?",
    "description": "V1 and V2."
  },
  {
    "id": 40,
    "topic_id": 1,
    "title": "You need to establish a connection on a wall jack to connect to the desktop. What tool will you use?",
    "description": "Snips."
  },
  {
    "id": 41,
    "topic_id": 2,
    "title": "Which wireless standards are in the 5 GHz frequency range?",
    "description": "802.11a, 802.11n, 802.11ac, and 802.11ax."
  },
  {
    "id": 42,
    "topic_id": 5,
    "title": "Wireless users said they are having intermittent problems. All the wired users are fine. What should you check?",
    "description": "The antenna location."
  },
  {
    "id": 43,
    "topic_id": 5,
    "title": "Users are calling and complaining that they cannot get to the Internet. You check and none of them has an IP address. What device do you check?",
    "description": "DHCP server."
  },
  {
    "id": 44,
    "topic_id": 5,
    "title": "What is the broadcast address of 192.168.192.20/29?",
    "description": "A /29 is 255.255.255.248, which is a block size of 8 in the fourth octet. The subnet is 192.168.192.16. Therefore, the broadcast address is 192.168.192.23."
  },
  {
    "id": 45,
    "topic_id": 5,
    "title": "A wireless network with two hosts and no access point is called what?",
    "description": "Ad hoc."
  },
  {
    "id": 46,
    "topic_id": 3,
    "title": "What does port mirroring provide?",
    "description": "The ability to see frames sent to all or some of the ports on the switch with your analyzer."
  },
  {
    "id": 47,
    "topic_id": 1,
    "title": "Which device filters packets based on rules that have been configured for it?",
    "description": "Firewall."
  },
  {
    "id": 48,
    "topic_id": 4,
    "title": "You have no money in your budget, but your boss wants smaller broadcast domains used with your switches. What do you do?",
    "description": "Create VLANs."
  },
  {
    "id": 49,
    "topic_id": 4,
    "title": "What type of security threat allows an attacker to learn your password through the use of an email or phone call?",
    "description": "Social engineering or phishing."
  },
  {
    "id": 50,
    "topic_id": 4,
    "title": "What device do you need to route packets over a wireless network?",
    "description": "A wireless access point. Don\u2019t get confused by the word <i>route</i>."
  },
  {
    "id": 51,
    "topic_id": 1,
    "title": "What is the default administrative distance of RIP?",
    "description": "120."
  },
  {
    "id": 52,
    "topic_id": 1,
    "title": "What is the default administrative distance of EIGRP?",
    "description": "90."
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "What is the default administrative distance of RIPv2?",
    "description": "120."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "What is the default administrative distance of a static route?",
    "description": "1."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "What is the version or name of RIP that is used with IPv6?",
    "description": "RIPng."
  },
  {
    "id": 56,
    "topic_id": 1,
    "title": "What is the version or name of OSPF that is used with IPv6?",
    "description": "OSPFv3."
  },
  {
    "id": 57,
    "topic_id": 1,
    "title": "What is the version or name of EIGRP that is used with IPv6?",
    "description": "EIGRPv6."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "Is BGP considered link state or distance vector?",
    "description": "Distance vector."
  },
  {
    "id": 59,
    "topic_id": 1,
    "title": "True/False: A bit is one digit, either a 1 or a 0.",
    "description": "True."
  },
  {
    "id": 60,
    "topic_id": 1,
    "title": "True/False: The Class C private address range is 172.16.0.0 through 172.31.255.255.",
    "description": "False. That is the Class B range."
  },
  {
    "id": 61,
    "topic_id": 1,
    "title": "True/False: The Class C private address range is 192.168.0.0 through 192.168.255.255.",
    "description": "True."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "What is the 127.0.0.1 address used for?",
    "description": "Loopback; testing of your local IP stack."
  },
  {
    "id": 63,
    "topic_id": 1,
    "title": "Which layer of the OSI model chooses and determines the availability of communicating partners along with the resources necessary to make the connection?",
    "description": "Application."
  },
  {
    "id": 64,
    "topic_id": 2,
    "title": "Which layer of the OSI model defines how data is formatted, presented, encoded, and converted?",
    "description": "Presentation."
  },
  {
    "id": 65,
    "topic_id": 1,
    "title": "Which layer of the OSI model is responsible for creating, managing, and terminating sessions between applications?",
    "description": "Session."
  },
  {
    "id": 66,
    "topic_id": 1,
    "title": "Name the protocol that uses both TCP ports 20 and 21.",
    "description": "FTP."
  },
  {
    "id": 67,
    "topic_id": 2,
    "title": "Which Network layer protocol dynamically reports errors to source hosts by using IP directly to build packets?",
    "description": "Internet Control Message Protocol (ICMP)."
  },
  {
    "id": 68,
    "topic_id": 1,
    "title": "Which terminal emulation program is used in the same way Telnet is used but is encrypted?",
    "description": "Secure Shell (SSH)."
  },
  {
    "id": 69,
    "topic_id": 1,
    "title": "Which Transport layer protocol does a TFTP client use to transfer files over the network?",
    "description": "UDP."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "Which destination port number does a TFTP client use to transfer files over the network?",
    "description": "69."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "What is the lowest level of class of service called?",
    "description": "At layer 2, the class of service is called best effort."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "If you need to connect two PCs directly together using their network adapters, what type of cable do you need?",
    "description": "Crossover."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "Which network performance optimization technique uses a contract to determine which data can get onto the network?",
    "description": "Traffic shaping."
  },
  {
    "id": 74,
    "topic_id": 3,
    "title": "Spreading network traffic across multiple connections is called ___________________.",
    "description": "Load balancing."
  },
  {
    "id": 75,
    "topic_id": 5,
    "title": "True/False: A cache is a collection of data duplicating some original data.",
    "description": "True."
  },
  {
    "id": 76,
    "topic_id": 3,
    "title": "What is the broadcast address of 192.168.192.10/29?",
    "description": "A /29 is 255.255.255.248, which is a block size of 8 in the fourth octet. The subnet is 192.168.192.8. Therefore, the broadcast address is 192.168.192.15."
  },
  {
    "id": 77,
    "topic_id": 1,
    "title": "True/False: A /27 is a block size of 16.",
    "description": "False. It is a block of 32."
  },
  {
    "id": 78,
    "topic_id": 2,
    "title": "True/False: A /28 is a block size of 16.",
    "description": "True."
  },
  {
    "id": 79,
    "topic_id": 2,
    "title": "True/False: The /30 mask will provide you with only two hosts per network.",
    "description": "True."
  },
  {
    "id": 80,
    "topic_id": 2,
    "title": "When should you use plenum-rated cable?",
    "description": "When installing cable in ceilings or other spaces used for air circulation."
  },
  {
    "id": 81,
    "topic_id": 2,
    "title": "True/False: SNAT is a type of network address translation (NAT).",
    "description": "True."
  },
  {
    "id": 82,
    "topic_id": 2,
    "title": "True/False: Addresses used after NAT translations are called global addresses.",
    "description": "True."
  },
  {
    "id": 83,
    "topic_id": 2,
    "title": "True/False: A Class C address has a default subnet mask of 255.255.255.0.",
    "description": "False."
  },
  {
    "id": 84,
    "topic_id": 2,
    "title": "True/False: Bridges are hardware based, whereas switches are software based because they use ASIC chips to help make filtering decisions.",
    "description": "False."
  },
  {
    "id": 85,
    "topic_id": 3,
    "title": "True/False: Bridges and switches learn MAC addresses by examining the source address of each frame received.",
    "description": "True."
  },
  {
    "id": 86,
    "topic_id": 2,
    "title": "VLANs break up ___________________ domains in a layer 2 switched network.",
    "description": "Broadcast."
  },
  {
    "id": 87,
    "topic_id": 2,
    "title": "Switches, by default, break up only ___________________ domains.",
    "description": "Collision."
  },
  {
    "id": 88,
    "topic_id": 4,
    "title": "Which port configuration of a switch allows two switches to pass VLAN information?",
    "description": "Trunking."
  },
  {
    "id": 89,
    "topic_id": 2,
    "title": "What is used at layer 2 to prevent switching loops?",
    "description": "Spanning Tree Protocol (STP)."
  },
  {
    "id": 90,
    "topic_id": 2,
    "title": "Which switching technology reduces the size of a broadcast domain?",
    "description": "VLAN."
  },
  {
    "id": 91,
    "topic_id": 1,
    "title": "Which UTP wiring uses four twisted wire pairs (eight wires) and is rated for 250 MHz?",
    "description": "Category 6."
  },
  {
    "id": 92,
    "topic_id": 3,
    "title": "The point at which the operational control or ownership changes from your company to a service provider is referred to as the ___________________.",
    "description": "Demarcation point, or demarc."
  },
  {
    "id": 93,
    "topic_id": 2,
    "title": "True/False: Crossover cable is used to connect switches together.",
    "description": "True."
  },
  {
    "id": 94,
    "topic_id": 2,
    "title": "Which RG rating of coax is used for cable modems?",
    "description": "RG-6."
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "True/False: A straight-through cable uses only pins 1 to 3 and pins 2 to 6.",
    "description": "False. A straight-through cable should always be made using all four pairs of wires."
  },
  {
    "id": 96,
    "topic_id": 3,
    "title": "You want to connect a host to a switch port. What type of Ethernet cable will you use?",
    "description": "Straight-through."
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "Which UTP cable category uses four twisted wire pairs (eight wires), is rated for 100 MHz, and is capable of handling the disturbance on each pair caused by transmitting on all four pairs at the same time?",
    "description": "Category 5e."
  },
  {
    "id": 98,
    "topic_id": 3,
    "title": "True/False: Unshielded twisted-pair (UTP) is commonly used in twisted-pair Ethernet (10BaseT, 100BaseTX, 1000BaseT, and so on).",
    "description": "True."
  },
  {
    "id": 99,
    "topic_id": 2,
    "title": "True/False: Fiber-optic cable uses a serial DB connector.",
    "description": "False."
  },
  {
    "id": 100,
    "topic_id": 3,
    "title": "The maximum segment length of twisted-pair cable is ___________________.",
    "description": "100 meters (328 feet)."
  },
  {
    "id": 101,
    "topic_id": 3,
    "title": "True/False: Straight-through cable is used to connect a host to a switch or hub or a router to a switch or hub.",
    "description": "True."
  },
  {
    "id": 102,
    "topic_id": 2,
    "title": "True/False: Eight wires are used in straight-through cable to connect 10/100/1000 Ethernet devices.",
    "description": "False."
  },
  {
    "id": 103,
    "topic_id": 3,
    "title": "Which type of cable is used to connect a hub to a switch?",
    "description": "Crossover."
  },
  {
    "id": 104,
    "topic_id": 2,
    "title": "Which type of cable is used to connect a switch to a switch?",
    "description": "Crossover."
  },
  {
    "id": 105,
    "topic_id": 3,
    "title": "Which type of cable should be used to connect to the console port on a router?",
    "description": "Rolled (console)."
  },
  {
    "id": 106,
    "topic_id": 2,
    "title": "True/False: A patch panel is typically a rack- or wall-mounted structure that houses cable connections.",
    "description": "True."
  },
  {
    "id": 107,
    "topic_id": 2,
    "title": "True/False: A repeater can be used to cache web pages for future retrieval.",
    "description": "False."
  },
  {
    "id": 108,
    "topic_id": 1,
    "title": "True/False: A proxy server can be used to cache web pages for future retrieval.",
    "description": "True."
  },
  {
    "id": 109,
    "topic_id": 1,
    "title": "When all routers in an autonomous system agree about the path from one point to another, the network is said to be what?",
    "description": "Converged."
  },
  {
    "id": 110,
    "topic_id": 1,
    "title": "Which is a protocol used to secure access to a VPN?",
    "description": "IPSec."
  },
  {
    "id": 111,
    "topic_id": 1,
    "title": "What tool is used to connect an RJ-45 connector to a UTP cable?",
    "description": "Crimper."
  },
  {
    "id": 112,
    "topic_id": 5,
    "title": "What type of cable connects to a 66 block from the telecommunication company?",
    "description": "25 pair."
  },
  {
    "id": 113,
    "topic_id": 5,
    "title": "Implementing policies and procedures that define how corporate information is kept confidential and training employees on these procedures can help prevent what?",
    "description": "Social engineering."
  },
  {
    "id": 114,
    "topic_id": 5,
    "title": "At what layer of the Open Systems Interconnection (OSI) model does a router function?",
    "description": "Network (layer 3)."
  },
  {
    "id": 115,
    "topic_id": 5,
    "title": "Which TCP/IP well-known port number identifies Simple Mail Transfer Protocol (SMTP)?",
    "description": "25."
  },
  {
    "id": 116,
    "topic_id": 3,
    "title": "Which routing protocol uses a next hop as a metric in deciding how to route traffic?",
    "description": "Routing Information Protocol (RIP)."
  },
  {
    "id": 117,
    "topic_id": 5,
    "title": "True/False: 156.144.226.123 is a valid IP address.",
    "description": "True."
  },
  {
    "id": 118,
    "topic_id": 4,
    "title": "Which device monitors inbound and outbound network connections to identify suspicious activity?",
    "description": "Intrusion detection system (IDS)."
  },
  {
    "id": 119,
    "topic_id": 1,
    "title": "True/False: The Transport layer converts digital data into electronic signals to be put on a wire.",
    "description": "False."
  },
  {
    "id": 120,
    "topic_id": 4,
    "title": "Which two commands can you type to see the DNS servers that your computer is using?",
    "description": "nslookup and ipconfig."
  },
  {
    "id": 121,
    "topic_id": 3,
    "title": "True/False: Internet Protocol Security (IPSec) encrypts data between web browsers and web servers.",
    "description": "False."
  },
  {
    "id": 122,
    "topic_id": 4,
    "title": "Which device or software can identify and react to an attack by shutting down a port or dropping certain types of packets?",
    "description": "Intrusion prevention system (IPS)."
  },
  {
    "id": 123,
    "topic_id": 4,
    "title": "True/False: Using the Domain Name System (DNS) will segment a network.",
    "description": "False."
  },
  {
    "id": 124,
    "topic_id": 4,
    "title": "True/False: TCP is connection-oriented, and UDP is unreliable.",
    "description": "True."
  },
  {
    "id": 125,
    "topic_id": 3,
    "title": "When configuring a wireless access point, what should you consider when selecting a channel?",
    "description": "Select a channel farthest from that of any other AP in the area."
  },
  {
    "id": 126,
    "topic_id": 1,
    "title": "What does SNMP provide?",
    "description": "Automated alerts and reports on network devices."
  },
  {
    "id": 127,
    "topic_id": 1,
    "title": "What protocol is a distance vector routing protocol that supports IPv6?",
    "description": "Routing Information Protocol Next Generation (RIPng)."
  },
  {
    "id": 128,
    "topic_id": 1,
    "title": "What is the multicast address RIPv2 uses for sending updates?",
    "description": "224.0.0.9."
  },
  {
    "id": 129,
    "topic_id": 1,
    "title": "What protocol does EIGRP use for calculating routes?",
    "description": "Diffusing Update Algorithm (DUAL)."
  },
  {
    "id": 130,
    "topic_id": 1,
    "title": "What is the multicast address EIGRP uses for maintaining the neighbor table?",
    "description": "224.0.0.10."
  },
  {
    "id": 131,
    "topic_id": 1,
    "title": "Which criteria are used to elect the designated router for OSPF?",
    "description": "The highest router ID (RID) in the network."
  },
  {
    "id": 132,
    "topic_id": 2,
    "title": "What protocol is considered a path-vector routing protocol?",
    "description": "Border Gateway Protocol (BGP)."
  },
  {
    "id": 133,
    "topic_id": 1,
    "title": "What is required before you can advertise a network with BGP?",
    "description": "A registered autonomous system number (ASN) from a regional Internet registry (RIR)."
  },
  {
    "id": 134,
    "topic_id": 2,
    "title": "What is the protocol and port BGP uses to communicate with peers?",
    "description": "TCP port 179."
  },
  {
    "id": 135,
    "topic_id": 1,
    "title": "How many bits does an IPv6 address contain?",
    "description": "128 bits."
  },
  {
    "id": 136,
    "topic_id": 1,
    "title": "What is the IPv6 prefix for link-local addresses?",
    "description": "FE80::/10."
  },
  {
    "id": 137,
    "topic_id": 1,
    "title": "What is the IPv6 prefix for unique local addresses?",
    "description": "FC00::/7."
  },
  {
    "id": 138,
    "topic_id": 1,
    "title": "What IPv6 transitional technology is used to encapsulate IPv6 in IPv4 packets?",
    "description": "6to4 encapsulation."
  },
  {
    "id": 139,
    "topic_id": 3,
    "title": "What ICMPv6 packet is sent out from the client for the autoconfiguration of the IPv6 network and gateway?",
    "description": "Router solicitation (RS)."
  },
  {
    "id": 140,
    "topic_id": 1,
    "title": "What protocol replaces ARP in IPv6 communications?",
    "description": "Neighbor Discovery Protocol (NDP)."
  },
  {
    "id": 141,
    "topic_id": 4,
    "title": "What ICMPv6 packet is sent out from the gateway to IPv6 hosts for autoconfiguration purposes?",
    "description": "Router advertisement (RA)."
  },
  {
    "id": 142,
    "topic_id": 5,
    "title": "What is the IPv6 prefix for global unicast addresses?",
    "description": "2000::/3."
  },
  {
    "id": 143,
    "topic_id": 1,
    "title": "What is the layer 3 QoS method used for the priority of traffic?",
    "description": "Differentiated Services Code Point (DSCP), or Diffserv."
  },
  {
    "id": 144,
    "topic_id": 1,
    "title": "What is the layer 2 QoS method used for the priority of traffic?",
    "description": "Class of service (CoS)."
  },
  {
    "id": 145,
    "topic_id": 4,
    "title": "What is the IPv6 prefix for multicast addresses?",
    "description": "FF00::/8."
  },
  {
    "id": 146,
    "topic_id": 1,
    "title": "What is the method of allowing multiple private IP addresses to share one public IP address?",
    "description": "Port address translation (PAT)."
  },
  {
    "id": 147,
    "topic_id": 3,
    "title": "What is the method of mapping a private IP address to a public IP address?",
    "description": "Static port address translation (SPAT)."
  },
  {
    "id": 148,
    "topic_id": 3,
    "title": "What is used to restrict and control traffic on a router?",
    "description": "Access control lists (ACLs)."
  },
  {
    "id": 149,
    "topic_id": 3,
    "title": "What is the term used to describe the programmability of network switching equipment?",
    "description": "Software-defined networking (SDN)."
  },
  {
    "id": 150,
    "topic_id": 1,
    "title": "What are the three networks defined in RFC 1918 for private IP addressing?",
    "description": "10.0.0.0/8, 172.16.0.0/12, and 192.168.0.0/16."
  },
  {
    "id": 151,
    "topic_id": 1,
    "title": "What are the five Internet registries in the world?",
    "description": "AFRINIC, APNIC, ARIN, LACNIC, and RIP NCC."
  },
  {
    "id": 152,
    "topic_id": 1,
    "title": "Name the open standard First Hop Redundancy Protocol (FHRP).",
    "description": "Virtual Router Redundancy Protocol (VRRP)."
  },
  {
    "id": 153,
    "topic_id": 2,
    "title": "How many hosts can be addressed in the network of 192.168.1.0/28?",
    "description": "14 hosts."
  },
  {
    "id": 154,
    "topic_id": 2,
    "title": "How many networks can be addresses if you use a network mask of 255.255.255.248?",
    "description": "32 networks."
  },
  {
    "id": 155,
    "topic_id": 2,
    "title": "Is 192.168.1.64/28 a valid IP address?",
    "description": "No, 192.168.1.64 is a network ID."
  },
  {
    "id": 156,
    "topic_id": 2,
    "title": "Is 172.16.4.0/21 a valid IP address?",
    "description": "Yes, the network ID the host belongs to is 172.16.0.0/21."
  },
  {
    "id": 157,
    "topic_id": 2,
    "title": "What class is the IP address 192.23.87.5?",
    "description": "Class B."
  },
  {
    "id": 158,
    "topic_id": 2,
    "title": "What class is the IP address 239.34.23.4?",
    "description": "Class D (Multicast)."
  },
  {
    "id": 159,
    "topic_id": 2,
    "title": "What is the process DHCP uses to assign an IP address?",
    "description": "Discover, Offer, Request, Acknowledge (DORA)."
  },
  {
    "id": 160,
    "topic_id": 2,
    "title": "What is the default mode of DHCPv6 for autoconfiguration of IP addresses?",
    "description": "Stateless mode."
  },
  {
    "id": 161,
    "topic_id": 2,
    "title": "What is the mode of DHCPv6 that will use centralized leases?",
    "description": "Stateful mode."
  },
  {
    "id": 162,
    "topic_id": 2,
    "title": "What is the Microsoft name for link-local IP addressing?",
    "description": "Automatic Private IP Addressing (APIPA)."
  },
  {
    "id": 163,
    "topic_id": 2,
    "title": "What can you tell from the IPv6 address of 2001:0DB8:0045:0000:0212:34FF:FEAA:BBCC?",
    "description": "It is a globally unique IP address with EUI-64 host addressing."
  },
  {
    "id": 164,
    "topic_id": 2,
    "title": "What type of topology is used with Ethernet?",
    "description": "Star topology."
  },
  {
    "id": 165,
    "topic_id": 2,
    "title": "What type of topology is used with FDDI?",
    "description": "Ring topology."
  },
  {
    "id": 166,
    "topic_id": 2,
    "title": "How many connections are in a fully meshed network with five switches?",
    "description": "[5(5-1)]/2 = [5(4)]/2 = 20/2 = 10 connections."
  },
  {
    "id": 167,
    "topic_id": 2,
    "title": "What type of topology is used with SCSI networks?",
    "description": "Bus topology."
  },
  {
    "id": 168,
    "topic_id": 2,
    "title": "Your boss tells you to block certain ports on your firewall. What documentation do you need to update?",
    "description": "Policies, procedures, and configurations."
  },
  {
    "id": 169,
    "topic_id": 1,
    "title": "You need to provide inter-VLAN communication. What device do you need?",
    "description": "A layer 3 switch (router)."
  },
  {
    "id": 170,
    "topic_id": 3,
    "title": "True/False: Anti-malware software will help protect a computer from hackers.",
    "description": "False."
  },
  {
    "id": 171,
    "topic_id": 3,
    "title": "True/False: Anti-malware software will help protect a computer from Trojan horses.",
    "description": "True."
  },
  {
    "id": 172,
    "topic_id": 1,
    "title": "A packet-filtering firewall operates at which layers of the OSI model?",
    "description": "Network and Transport."
  },
  {
    "id": 173,
    "topic_id": 5,
    "title": "True/False: A packet-filtering firewall operates at the Network and Data Link layers of the OSI model.",
    "description": "False."
  },
  {
    "id": 174,
    "topic_id": 3,
    "title": "Which networking topology connects computers via a central device?",
    "description": "Hub and spoke (star)."
  },
  {
    "id": 175,
    "topic_id": 3,
    "title": "True/False: A mesh networking topology connects computers via a central hub.",
    "description": "False."
  },
  {
    "id": 176,
    "topic_id": 3,
    "title": "True/False: A cable modem selectively forwards data packets.",
    "description": "False."
  },
  {
    "id": 177,
    "topic_id": 3,
    "title": "True/False: A bridge can selectively forward data packets.",
    "description": "True."
  },
  {
    "id": 178,
    "topic_id": 3,
    "title": "True/False: A bridge is a network device that operates at layer 2 of the OSI model.",
    "description": "True."
  },
  {
    "id": 179,
    "topic_id": 3,
    "title": "True/False: A switch is a network device that operates at layer 2 of the OSI model.",
    "description": "True."
  },
  {
    "id": 180,
    "topic_id": 3,
    "title": "True/False: A hub and a repeater operate at layer 2 of the OSI model.",
    "description": "False."
  },
  {
    "id": 181,
    "topic_id": 3,
    "title": "True/False: A hub and a switch operate at the same layer of the OSI model.",
    "description": "False."
  },
  {
    "id": 182,
    "topic_id": 1,
    "title": "True/False: A hub and router operate at the same layer of the OSI model.",
    "description": "False."
  },
  {
    "id": 183,
    "topic_id": 1,
    "title": "True/False: A router and a bridge operate at the same layer of the OSI model.",
    "description": "False."
  },
  {
    "id": 184,
    "topic_id": 1,
    "title": "What is 01100011.00011010 in decimal?",
    "description": "99.26."
  },
  {
    "id": 185,
    "topic_id": 1,
    "title": "A company wants to have an intranet. Where would the intranet web server be located in the network?",
    "description": "In the local area network (LAN), usually behind the firewall to the WAN."
  },
  {
    "id": 186,
    "topic_id": 1,
    "title": "True/False: A network administrator wants all computers protected from malware. Implementing a firewall will accomplish this requirement.",
    "description": "False."
  },
  {
    "id": 187,
    "topic_id": 5,
    "title": "HTTPS uses what TCP destination port number?",
    "description": "443."
  },
  {
    "id": 188,
    "topic_id": 5,
    "title": "True/False: Virtual local area networks (VLANs) create collision domains.",
    "description": "False."
  },
  {
    "id": 189,
    "topic_id": 5,
    "title": "Which routing protocol uses a composite metric of bandwidth and delay of the line to find the best path to a remote network?",
    "description": "Enhanced Interior Gateway Routing Protocol (EIGRP)."
  },
  {
    "id": 190,
    "topic_id": 3,
    "title": "Which command-line tool determines whether a particular IP host is responding?",
    "description": "ping."
  },
  {
    "id": 191,
    "topic_id": 2,
    "title": "You need your IP address, subnet mask, default gateway, and DNS information. What command will you type from a Windows command prompt?",
    "description": "ipconfig /all."
  },
  {
    "id": 192,
    "topic_id": 5,
    "title": "Which utility is used to view TCP/IP configuration for a computer?",
    "description": "ipconfig."
  },
  {
    "id": 193,
    "topic_id": 4,
    "title": "Which command will display the current contents of the ARP cache on the local workstation?",
    "description": "arp -a."
  },
  {
    "id": 194,
    "topic_id": 4,
    "title": "Which nbtstat switch displays a list of all the NetBIOS names on the local workstation?",
    "description": "nbtstat \u2013s."
  },
  {
    "id": 195,
    "topic_id": 4,
    "title": "A network device that is used to connect multiple devices without segmenting a network is a ___________________.",
    "description": "Hub."
  },
  {
    "id": 196,
    "topic_id": 4,
    "title": "The Spanning Tree Protocol allows for redundancy of what networking device?",
    "description": "Bridge (switch)."
  },
  {
    "id": 197,
    "topic_id": 4,
    "title": "Which device can operate at both layer 2 and layer 3 of the OSI model?",
    "description": "Layer 3 switch."
  },
  {
    "id": 198,
    "topic_id": 4,
    "title": "SMTP resides at what layer of the OSI model?",
    "description": "Application."
  },
  {
    "id": 199,
    "topic_id": 4,
    "title": "A user discovers that their wireless 802.11g Internet connection is intermittently disrupted. What can typically cause this problem?",
    "description": "Cordless phones and/or microwave ovens."
  },
  {
    "id": 200,
    "topic_id": 2,
    "title": "Which device helps to increase the number of collision domains?",
    "description": "Switch."
  },
  {
    "id": 201,
    "topic_id": 2,
    "title": "Which wireless standard has a maximum data rate of 11 Mbps?",
    "description": "802.11b."
  },
  {
    "id": 202,
    "topic_id": 4,
    "title": "What functionality does Kerberos provide?",
    "description": "Authentication of security principles and authorization of access to resources."
  },
  {
    "id": 203,
    "topic_id": 1,
    "title": "What TCP/IP port numbers does FTP utilize?",
    "description": "20 and 21. 20 is FTP data or a client, and 21 is an FTP server."
  },
  {
    "id": 204,
    "topic_id": 1,
    "title": "At what layer of the OSI model does UDP reside?",
    "description": "Transport."
  },
  {
    "id": 205,
    "topic_id": 1,
    "title": "Convert the following binary string to its dotted-decimal address: 11000000.10101000.01100011.00011010",
    "description": "192.168.99.26."
  },
  {
    "id": 206,
    "topic_id": 1,
    "title": "100BaseTX uses how many pairs of Category 5 unshielded twisted-pair (UTP) cables?",
    "description": "Two pairs."
  },
  {
    "id": 207,
    "topic_id": 2,
    "title": "What device connects computers with wireless adapters to a network in infrastructure mode?",
    "description": "Access point."
  },
  {
    "id": 208,
    "topic_id": 1,
    "title": "The maximum segment length for Ethernet is ___________________.",
    "description": "100 meters (328 feet)."
  },
  {
    "id": 209,
    "topic_id": 2,
    "title": "What is the maximum speed of 802.11g?",
    "description": "54 Mbps (megabits per second)."
  },
  {
    "id": 210,
    "topic_id": 2,
    "title": "Which techniques would increase the bandwidth for network transmission by joining multiple connections into one logical connection?",
    "description": "Bonding."
  },
  {
    "id": 211,
    "topic_id": 4,
    "title": "True/False: Firewalls are used to prevent packets from entering and leaving a network.",
    "description": "True."
  },
  {
    "id": 212,
    "topic_id": 1,
    "title": "Which networking device can never run full-duplex?",
    "description": "A hub."
  },
  {
    "id": 213,
    "topic_id": 200,
    "title": "Know your network topologies.",
    "description": "Know the names and descriptions of the topologies. Be aware of the difference between physical networks (what humans see) and logical networks (what the equipment \u201csees\u201d)."
  },
  {
    "id": 214,
    "topic_id": 200,
    "title": "Know the advantages and disadvantages of the topologies.",
    "description": "It is essential to know what each topology brings to the table. Knowing the various characteristics of each topology comes in handy during troubleshooting."
  },
  {
    "id": 215,
    "topic_id": 200,
    "title": "Understand the terms LAN and WAN.",
    "description": "You need to understand when you would use a LAN and when you would use a WAN. A LAN is used to connect a group of hosts, and a WAN is used to connect various LANs."
  },
  {
    "id": 216,
    "topic_id": 200,
    "title": "Know the three-tiered model and collapsed core.",
    "description": "Know what the core, distribution, and access layer provide in the three-tier model. The collapsed core is used to reduce costs by collapsing the core and distribution tiers into one tier."
  },
  {
    "id": 217,
    "topic_id": 200,
    "title": "Understand the differences between north-south traffic and east-west traffic.",
    "description": "North-south traffic typically leaves the network through a routed connection. East-west traffic typically resides in the immediate network."
  },
  {
    "id": 218,
    "topic_id": 200,
    "title": "Memorize and understand the OSI layers.",
    "description": "You must remember and understand the seven layers of the OSI model and what function each layer provides. The Application, Presentation, and Session layers are the upper layers responsible for communicating from a user interface to an application. The Transport layer provides segmentation, sequencing, and virtual circuits. The Network layer provides logical network addressing and routing through the internetwork. The Data Link layer frames and places data on the network medium. The Physical layer is responsible for taking 1s and 0s and encoding them into a digital signal for transmission on the network segment."
  },
  {
    "id": 219,
    "topic_id": 200,
    "title": "Know the sublayers of the Data Link layer.",
    "description": "In addition to the OSI layers, knowing that the Data Link layer is the only layer that has sublayers and the functions of those sublayers is extremely important. The Data Link layer has two sublayers: LLC and MAC. The LLC sublayer is responsible primarily for the multiplexing of Network layer protocols. The MAC sublayer is responsible for physical addressing and determining the appropriate time to place data on the network."
  },
  {
    "id": 220,
    "topic_id": 200,
    "title": "Know the various types of cables used in today's networks.",
    "description": "Coaxial (other than for cable modems) is rarely used, but twisted-pair cable and fiber-optic cable are very common in today's networks."
  },
  {
    "id": 221,
    "topic_id": 200,
    "title": "Know the various types of ends that are used on each type of cable.",
    "description": "Coax uses BNC; twisted-pair uses RJ-11 for voice and RJ-45 for data; and fiber uses various ends, depending on its use. Know how to identify each type of connector."
  },
  {
    "id": 222,
    "topic_id": 200,
    "title": "Describe the various types of media converters that are available.",
    "description": "These include single-mode fiber to Ethernet, multimode fiber to Ethernet, fiber to coaxial, and single-mode to multimode fiber."
  },
  {
    "id": 223,
    "topic_id": 200,
    "title": "Understand what a T568A to T568A cable is.",
    "description": "A T568A to T568A cable is also known as an Ethernet straight-through cable and is used to connect hosts to switches, for example."
  },
  {
    "id": 224,
    "topic_id": 200,
    "title": "Understand what a T568A to T568B cable is.",
    "description": "A T568A to T568B cable is also known as an Ethernet crossover cable and is used to connect switches to switches, for example."
  },
  {
    "id": 225,
    "topic_id": 200,
    "title": "Define the function of a T1 crossover cable.",
    "description": "In rare instances, you may have the need to run a cable between two CSU/DSUs."
  },
  {
    "id": 226,
    "topic_id": 200,
    "title": "Know the various transceivers in use.",
    "description": "You should know how to identify the SFP, QSFP, FC, and Ethernet transceivers. In addition, you should know the benefits of each of the transceivers."
  },
  {
    "id": 227,
    "topic_id": 200,
    "title": "Understand basic Ethernet communication.",
    "description": "Know how hosts use hardware addresses to communicate on an Ethernet LAN."
  },
  {
    "id": 228,
    "topic_id": 200,
    "title": "Understand Ethernet addressing.",
    "description": "Know the hexadecimal addressing scheme used to create an Ethernet address."
  },
  {
    "id": 229,
    "topic_id": 200,
    "title": "Understand binary, decimal, and hexadecimal addressing.",
    "description": "Know the different addressing types, and also use the written lab to practice your conversions."
  },
  {
    "id": 230,
    "topic_id": 200,
    "title": "Know the various Ethernet standards.",
    "description": "This includes understanding the various copper and fiber-based standards."
  },
  {
    "id": 231,
    "topic_id": 200,
    "title": "Understand how DHCP works and its purpose.",
    "description": "Dynamic Host Configuration Protocol (DHCP) provides IP configuration information to hosts. It is important to know how a DHCP client requests information from a server, how a server receives this information, and also how the server responds to the client and with what type of information."
  },
  {
    "id": 232,
    "topic_id": 200,
    "title": "Understand how DNS works and its purpose.",
    "description": "The Domain Name System (DNS) is used to resolve human names to IP addresses. Understanding how DNS resolves these names is critical, as is understanding how a DNS query is sent and how a DNS server responds. Know the different types of DNS records and what they are used for."
  },
  {
    "id": 233,
    "topic_id": 200,
    "title": "Understand the difference between a hub, a switch (bridge), and a router.",
    "description": "A hub just connects network segments together. A switch/bridge segments the network using MAC addresses, and a router segments the network using logical addressing (IP and IPv6). Switches break up collision domains, and routers break up broadcast domains by default."
  },
  {
    "id": 234,
    "topic_id": 200,
    "title": "Remember the different names for a router.",
    "description": "A router is a layer 3 hardware device, but it can also be called a layer 3 switch or a multilayer switch."
  },
  {
    "id": 235,
    "topic_id": 200,
    "title": "Remember the various devices used on networks today and when you would use each one and how.",
    "description": "Understand the differences and how each device works: routers, switches, hubs, DNS servers, and DHCP servers."
  },
  {
    "id": 236,
    "topic_id": 200,
    "title": "Identify the purpose, benefits, and characteristics of using a proxy service.",
    "description": "A proxy server keeps a LAN somewhat separated from the Internet. Doing so increases security and filtering control and has the tendency to speed up Internet access through caching of recently used web pages."
  },
  {
    "id": 237,
    "topic_id": 200,
    "title": "Describe the proper use of network segmentation when planning and implementing a basic SOHO network.",
    "description": "Understand and apply the concepts of proper network segmentation when planning the use of various devices in the design of a SOHO network."
  },
  {
    "id": 238,
    "topic_id": 200,
    "title": "Describe the benefits of using a network load balancer.",
    "description": "Network load balancers allow incoming connections to be spread out across multiple servers for scalability and resiliency. Understand the architecture of how load balancers are inserted into a network."
  },
  {
    "id": 239,
    "topic_id": 200,
    "title": "Describe the benefits of using dedicated appliances for certain services.",
    "description": "Using appliances to offload functions such as encryption, content filtering, and VPN concentrators can decrease the workload of other systems and add functionality that may be present in these dedicated devices."
  },
  {
    "id": 240,
    "topic_id": 200,
    "title": "Identify the environmental requirements of infrastructure devices.",
    "description": "A cool temperature, ample ventilation, and the proper humidity level are all keys to maintaining the operation of devices such as routers, switches, and appliances."
  },
  {
    "id": 241,
    "topic_id": 200,
    "title": "Remember the Process/Application layer protocols.",
    "description": "Telnet is a terminal-emulation program that allows you to log into a remote host and run programs. File Transfer Protocol (FTP) is a connection-oriented service that allows you to transfer files. Trivial FTP (TFTP) is a connectionless file transfer program. Review the other various applications discussed in this chapter."
  },
  {
    "id": 242,
    "topic_id": 200,
    "title": "Understand data encapsulation and decapsulation within the OSI model context.",
    "description": "This includes Ethernet header, the Internet Protocol (IP) header, Transmission Control Protocol (TCP)/User Datagram Protocol (UDP) headers, TCP flags, Payload, and Maximum transmission unit (MTU)."
  },
  {
    "id": 243,
    "topic_id": 200,
    "title": "Be able to explain common ports and protocols, their application, and encrypted alternatives.",
    "description": "Know all the protocols and ports listed in the CompTIA N+ objectives for FTP, SSH, SFTP, and many more."
  },
  {
    "id": 244,
    "topic_id": 200,
    "title": "Be able to identify and define protocol types.",
    "description": "This includes Internet Control Message Protocol (ICMP), TCP, UDP, Generic Routing Encapsulation (GRE), Internet Protocol Security (IPSec), Authentication Header (AH)/Encapsulating Security Payload (ESP), and Internet Key Exchange (IKE)."
  },
  {
    "id": 245,
    "topic_id": 200,
    "title": "Remember the Host-to-Host layer protocols.",
    "description": "Transmission Control Protocol (TCP) is a connection-oriented protocol that provides reliable network service by using acknowledgments and flow control. User Datagram Protocol (UDP) is a connectionless protocol that provides low overhead and is considered unreliable."
  },
  {
    "id": 246,
    "topic_id": 200,
    "title": "Remember the Internet layer protocols.",
    "description": "Internet Protocol (IP) is a connectionless protocol that provides logical network addressing and routing through the internetwork. Address Resolution Protocol (ARP) finds a hardware address from a known IP address. Internet Control Message Protocol (ICMP) provides diagnostics and Destination Unreachable messages."
  },
  {
    "id": 247,
    "topic_id": 200,
    "title": "Remember the Class A range.",
    "description": "The IP range for a Class A network is 1 through 126. This provides 8 bits of network addressing and 24 bits of host addressing by default."
  },
  {
    "id": 248,
    "topic_id": 200,
    "title": "Remember the Class B range.",
    "description": "The IP range for a Class B network is 128 through 191. Class B addressing provides 16 bits of network addressing and 16 bits of host addressing by default."
  },
  {
    "id": 249,
    "topic_id": 200,
    "title": "Remember the Class C range.",
    "description": "The IP range for a Class C network is 192 through 223. Class C addressing provides 24 bits of network addressing and 8 bits of host addressing by default."
  },
  {
    "id": 250,
    "topic_id": 200,
    "title": "Remember the private IP ranges.",
    "description": "The Class A private address range is 10.0.0.0 through 10.255.255.255. The Class B private address range is 172.16.0.0 through 172.31.255.255. The Class C private address range is 192.168.0.0 through 192.168.255.255."
  },
  {
    "id": 251,
    "topic_id": 200,
    "title": "Remember the APIPA range.",
    "description": "The IP address range for APIPA is 169.254.0.1 through 169.254.255.254. The client also configures itself with a default Class B subnet mask of 255.255.0.0."
  },
  {
    "id": 252,
    "topic_id": 200,
    "title": "Understand why we need IPv6.",
    "description": "Without IPv6, the world would soon be depleted of IP addresses."
  },
  {
    "id": 253,
    "topic_id": 200,
    "title": "Understand link-local.",
    "description": "Link-local addresses are like an IPv4 APIPA IP address, but they can't be routed at all, not even in your organization."
  },
  {
    "id": 254,
    "topic_id": 200,
    "title": "Understand unique local.",
    "description": "This, like link-local, is like a private IP address in IPv4 and cannot be routed to the Internet. However, the difference between link-local and unique local is that unique local can be routed within your organization or company."
  },
  {
    "id": 255,
    "topic_id": 200,
    "title": "Remember IPv6 addressing.",
    "description": "IPv6 addressing is not like IPv4 addressing. IPv6 addressing has much more address space and the address is 128 bits long, represented in hexadecimal, unlike an IPv4 address, which is only 32 bits long and represented in decimal."
  },
  {
    "id": 256,
    "topic_id": 200,
    "title": "Understand and be able to read an EUI-64 address with the 7th bit inverted.",
    "description": "Hosts can use autoconfiguration to obtain an IPv6 address, and one of the ways is through what is called EUI-64. This takes the unique MAC address of a host and inserts FF:FE in the middle of the address to change a 48-bit MAC address to a 64-bit interface ID. In addition to the 16 bits being inserted into the interface ID, the 7th bit of the first byte is inverted, typically from a 0 to a 1."
  },
  {
    "id": 257,
    "topic_id": 200,
    "title": "Remember the steps to subnet in your head.",
    "description": "Understand how IP addressing and subnetting work. First, determine your block size by using the 256-subnet mask math. Then, count your subnets and determine the broadcast address of each subnet\u2014it is always the number right before the next subnet. Your valid hosts are the numbers between the subnet address and the broadcast address."
  },
  {
    "id": 258,
    "topic_id": 200,
    "title": "Understand the various block sizes.",
    "description": "This is an important part of understanding IP addressing and subnetting. The valid block sizes are always 4, 8, 16, 32, 64, 128, and so on. You can determine your block size by using the 256-subnet mask math."
  },
  {
    "id": 259,
    "topic_id": 200,
    "title": "Remember the four diagnostic steps.",
    "description": "The four simple steps for troubleshooting are ping the loopback address, ping the NIC, ping the default gateway, and ping the remote device."
  },
  {
    "id": 260,
    "topic_id": 200,
    "title": "You must be able to find and fix an IP addressing problem.",
    "description": "Once you go through the four troubleshooting steps, you should be able to determine the IP addressing problem by drawing out the network and finding the valid and invalid hosts addressed in your network."
  },
  {
    "id": 261,
    "topic_id": 200,
    "title": "Understand basic NAT terminology.",
    "description": "You want to know the difference between inside local and inside global. Inside local is before translation, and inside global is after translation. Inside global is a registered address representing an inside host to an outside network. You should also understand PAT and how it works by using different port numbers to map multiple private IP addresses to a single registered IP address."
  },
  {
    "id": 262,
    "topic_id": 200,
    "title": "Understand the basic IP routing process.",
    "description": "You need to remember that the frame changes at each hop, but that the packet is never changed or manipulated in any way until it reaches the destination device."
  },
  {
    "id": 263,
    "topic_id": 200,
    "title": "Understand that MAC addresses are always local.",
    "description": "A MAC (hardware) address will be used only on a local LAN. It will never pass a router's interface."
  },
  {
    "id": 264,
    "topic_id": 200,
    "title": "Understand that a frame carries a packet to only two places.",
    "description": "A frame uses MAC (hardware) addresses to send a packet on a LAN. The frame will take the packet to either a host on the LAN or a router's interface if the packet is destined for a remote network."
  },
  {
    "id": 265,
    "topic_id": 200,
    "title": "Remember the difference between static and dynamic routing.",
    "description": "Static routing is where you, as the administrator, by hand add every route into every routing table on every router on the network. This is as much work as it sounds like, which is why we use dynamic routing protocols that do the work for us. Of course, we'll discuss dynamic routing protocols more in the next chapter, but the main job of a routing protocol is to update routing tables."
  },
  {
    "id": 266,
    "topic_id": 200,
    "title": "Understand the various dynamic routing protocols including RIP, OSPF, EIGRP, and BGP.",
    "description": "RIP is a distance-vector routing protocol. It sends the complete routing table out to all active interfaces every 30 seconds. RIP uses hop count to determine the best path to a remote network. EIGRP is also a distant-vector protocol that uses link-state characteristics to determine the best path to a remote network. BGP is an external protocol that uses a path vector protocol between autonomous systems. OSPF is an open-standard and link-state protocol that uses the Dijkstra algorithm for best path selection."
  },
  {
    "id": 267,
    "topic_id": 200,
    "title": "Be able to distinguish between link state vs. distance vector vs. hybrid.",
    "description": "Link-state protocols use an algorithm to learn more information about the internetwork. Distance-vector protocols use a hop count to determine neighbors. Hybrid protocols will use a combination of distance vector and link state to determine the best path selection."
  },
  {
    "id": 268,
    "topic_id": 200,
    "title": "Know what the Neighborhood Discovery Protocol (NDP) and Router Advertisement (RA) protocol is used for.",
    "description": "NDP is used in an IPv6 network to discover various information from neighboring devices. Router advertisements are used to detect the gateway out of the network."
  },
  {
    "id": 269,
    "topic_id": 200,
    "title": "Remember the differences between RIPv1 and RIPv2.",
    "description": "RIPv1 sends broadcasts every 30 seconds and has an AD of 120. RIPv2 sends multicasts (224.0.0.9) every 30 seconds and also has an AD of 120. RIPv2 sends subnet mask information with the route updates, which allows it to support classless networks and discontiguous networks. RIPv2 also supports authentication between routers, and RIPv1 does not."
  },
  {
    "id": 270,
    "topic_id": 200,
    "title": "Compare OSPF and RIPv1.",
    "description": "OSPF is a link-state protocol that supports VLSM and classless routing; RIPv1 is a distance-vector protocol that does not support VLSM and supports only classful routing."
  },
  {
    "id": 271,
    "topic_id": 200,
    "title": "Understand the various compatibility requirements.",
    "description": "Know the various compatibility strategies for supporting both IPv4 and IPv6. This should include tunneling of IPv6 through an IPv4 network, Teredo, ISATAP tunneling, and dual stack."
  },
  {
    "id": 272,
    "topic_id": 200,
    "title": "Remember the three switch functions.",
    "description": "Address learning, forward/filter decisions, and loop avoidance are the functions of a switch."
  },
  {
    "id": 273,
    "topic_id": 200,
    "title": "Understand the main purpose of the Spanning Tree Protocol in a switched LAN.",
    "description": "The main purpose of STP is to prevent switching loops in a network with redundant switched paths."
  },
  {
    "id": 274,
    "topic_id": 200,
    "title": "Remember the states of STP.",
    "description": "The purpose of the blocking state is to prevent the use of looped paths. A port in the listening state prepares to forward data frames without populating the MAC address table. A port in the learning state populates the MAC address table but doesn't forward data frames. A port in the forwarding state sends and receives all data frames on the bridged port. Last, a port in the disabled state is virtually nonoperational."
  },
  {
    "id": 275,
    "topic_id": 200,
    "title": "Remember to check a switch port's VLAN assignment when plugging in a new host.",
    "description": "If you plug a new host into a switch, then you must verify the VLAN membership of that port. If the membership is different than what is needed for that host, the host will not be able to reach the needed network services, such as a workgroup server."
  },
  {
    "id": 276,
    "topic_id": 200,
    "title": "Understand what PoE provides.",
    "description": "Power over Ethernet was created to provide power to devices that are connected to a switch port but that are not in a place that has a power outlet\u2014for example, an access point in a ceiling."
  },
  {
    "id": 277,
    "topic_id": 200,
    "title": "Understand what jumbo frames provide.",
    "description": "Jumbo frames allow the maximum transmission unit (MTU) to be extended to 9000 bytes from the default 1500 bytes."
  },
  {
    "id": 278,
    "topic_id": 200,
    "title": "List features that can be used to maintain the STP topology.",
    "description": "These include BPDU Guard, Root Guard, and flood guards."
  },
  {
    "id": 279,
    "topic_id": 200,
    "title": "Understand the IEEE 802.11a specification.",
    "description": "802.11a runs in the 5 GHz spectrum, and if you use the 802.11h extensions, you have 23 non-overlapping channels. 802.11a can run up to 54 Mbps, but only if you are less than 50 feet from an access point."
  },
  {
    "id": 280,
    "topic_id": 200,
    "title": "Understand the IEEE 802.11b specification.",
    "description": "IEEE 802.11b runs in the 2.4 GHz range and has three non-overlapping channels. It can handle long distances but with a maximum data rate of up to 11 Mbps."
  },
  {
    "id": 281,
    "topic_id": 200,
    "title": "Understand the IEEE 802.11g specification.",
    "description": "IEEE 802.11g is 802.11b's big brother and runs in the same 2.4 GHz range, but it has a higher data rate of 54 Mbps if you are less than 100 feet from an access point."
  },
  {
    "id": 282,
    "topic_id": 200,
    "title": "Understand the IEEE 802.11n specification.",
    "description": "IEEE 802.11n operates in the 2.4 GHz and 5 GHz range. Support for 5 GHz bands is optional. Its net data rate ranges from 54 Mbit/s to 600 Mbit/s. The standard also added support for multiple-input, multiple-output (MIMO) antennas."
  },
  {
    "id": 283,
    "topic_id": 200,
    "title": "Understand the IEEE 802.11ac specification.",
    "description": "IEEE 802.11ac-2013 is an amendment that builds on 802.11n. Changes include wider channels (80 or 160 MHz versus 40 MHz) in the 5 GHz band and more spatial streams (up to eight versus four). Wave 2 products include additional features like MU-MIMO, 160 MHz channel width support, support for more 5 GHz channels, and four spatial streams with four antennas."
  },
  {
    "id": 284,
    "topic_id": 200,
    "title": "Understand the IEEE 802.11ax specification.",
    "description": "IEEE 802.11ax is the successor to 802.11ac. It's marketed as Wi-Fi 6 (2.4 GHz and 5 GHz) and Wi-Fi 6E (6 GHz). It is also known as High Efficiency Wi-Fi, for the overall improvements to Wi-Fi 6. Data rates against the predecessor (802.11ac) are only 39%. For comparison, this improvement was nearly 500% for the other predecessors."
  },
  {
    "id": 285,
    "topic_id": 200,
    "title": "Understand the different Wi-Fi standards, frequencies, and ranges.",
    "description": "Wi-Fi standards are 802.11a/b/g/n/ac/ax using 2.4 GHz and 5 GHz. 802.11ac is also known as Wi-Fi 5, and 802.11ax is also known as Wi-Fi 6."
  },
  {
    "id": 286,
    "topic_id": 200,
    "title": "Remember the various service set identifiers (SSIDs).",
    "description": "SSIDs can use a basic service set, an extended service set, an independent service set (ad hoc), and a roaming service set."
  },
  {
    "id": 287,
    "topic_id": 200,
    "title": "Remember the antenna types.",
    "description": "Wi-Fi antennas can be Omni directional or directional."
  },
  {
    "id": 288,
    "topic_id": 200,
    "title": "Remember the encryption standards.",
    "description": "Encryption standards include Wi-Fi Protected Access (WPA), WPA2 Personal (Advanced Encryption Standard-AES), Temporal Key Integrity Protocol (TKIP), and WPA/WPA2 Enterprise (AES/TKIP)."
  },
  {
    "id": 289,
    "topic_id": 200,
    "title": "Remember the cellular technologies.",
    "description": "Technologies used in cellular communications include code division multiple access(CDMA), global System Mobile (GSM), Long-Term Evolution (LTE), and 3g, 4g, and 5g."
  },
  {
    "id": 290,
    "topic_id": 200,
    "title": "Understand MIMO/MU-MIMO.",
    "description": "MIMO is multiple-input, multiple output, which is widely used in 802.11n and 802.11zc. MU-MIMO is multiuser multiple input, multiple output, which is used in the new 802.11ax protocol."
  },
  {
    "id": 291,
    "topic_id": 200,
    "title": "Remember the wireless LAN modulation techniques.",
    "description": "Direct-sequence spread spectrum (DSSS) is the most widely used modulation technique, but it has speeds only to 11 Mbps. However, the old and pretty much no-longer used frequency-hopping spread spectrum (FHSS), although it is still used in old wireless devices like Bluetooth, isn't the technique of choice for either vendors or the 802.11 working group. To get the higher speeds needed in today's WLANs, we use orthogonal frequency-division multiplexing (OFDM) in 802.11g/a/n and 802.11ac/ax networks."
  },
  {
    "id": 292,
    "topic_id": 200,
    "title": "Understand how WPA works in a WLAN.",
    "description": "Wi-Fi Protected Access (WPA) is the security of choice in today's home and corporate networks. It provides both authentication and encryption (either TKIP or AES)."
  },
  {
    "id": 293,
    "topic_id": 200,
    "title": "Explain VPN architectures.",
    "description": "These include site-to-site VPNs, client-to-site VPN, clientless VPN, split tunnel versus full, and SSH VPN."
  },
  {
    "id": 294,
    "topic_id": 200,
    "title": "Describe SSL and TLS.",
    "description": "This includes the differences between the two and the advantages of TLS. It also includes common applications with respect to VPNs."
  },
  {
    "id": 295,
    "topic_id": 200,
    "title": "Identify other remote access solutions.",
    "description": "These include VNC, RDP, Remote Desktop Gateway, remote desktop connections, and virtual connections."
  },
  {
    "id": 296,
    "topic_id": 200,
    "title": "Understand in-band and out-of-band management.",
    "description": "In-band management is access via the network over SSH, Telnet, or some other network protocol. Out-of-band management is access via a method not connected to the network, such as a serial connection."
  },
  {
    "id": 297,
    "topic_id": 200,
    "title": "Understand how to use performance metrics.",
    "description": "These include device metrics such as temperature, central processing unit (CPU) usage, and memory and network metrics, such as bandwidth, latency, jitter, and packet loss."
  },
  {
    "id": 298,
    "topic_id": 200,
    "title": "Describe the operation of SNMP.",
    "description": "Identify the roles that traps, object identifiers (OIDs), and management information bases (MIBs) play in monitoring the network with SNMP."
  },
  {
    "id": 299,
    "topic_id": 200,
    "title": "Know the various versions of SNMP.",
    "description": "The two versions covered on the Network+ exam are v2c and v3. Version 3 allows for better authentication and encryption of messages."
  },
  {
    "id": 300,
    "topic_id": 200,
    "title": "Utilize network device logs in addressing system issues.",
    "description": "Locate relevant information by reviewing logs such as traffic logs and audit logs. Describe the use of Syslog in centralizing these logs."
  },
  {
    "id": 301,
    "topic_id": 200,
    "title": "Understand the importance of plans and procedures.",
    "description": "These include change management, incident response, disaster recovery, business continuity, and the system life cycle."
  },
  {
    "id": 302,
    "topic_id": 200,
    "title": "Describe hardening and security policies.",
    "description": "Among these are acceptable use, password, bring your own device (BYOD), remote access, and onboarding and offboarding policies."
  },
  {
    "id": 303,
    "topic_id": 200,
    "title": "Utilize common documentation.",
    "description": "These include physical network diagrams, floor plans, rack diagrams, intermediate distribution frame (IDF)/main distribution frame (MDF) documentation, logical network diagrams, wiring diagrams and site survey reports."
  },
  {
    "id": 304,
    "topic_id": 200,
    "title": "Identify common business agreements.",
    "description": "These agreements include nondisclosure agreements (NDA), service-level agreements (SLA), and memorandums of understanding (MOUs)."
  },
  {
    "id": 305,
    "topic_id": 200,
    "title": "Understand the importance of fault tolerance and high availability techniques.",
    "description": "These include load balancing, multipathing, NIC teaming, and router, switch, and firewall clusters."
  },
  {
    "id": 306,
    "topic_id": 200,
    "title": "Describe facilities and infrastructure redundancy techniques.",
    "description": "Among these are uninterruptible power supplies (UPSs), power distribution units (PDUs), generators, HVAC systems, fire suppression, and multiple Internet service providers (ISPs)/diverse paths."
  },
  {
    "id": 307,
    "topic_id": 200,
    "title": "Utilize disaster recovery techniques.",
    "description": "These include physical cold sites, warm sites, hot sites, and cloud sites. It also requires an understanding of RPO, MTTR, MTBF, and RTO."
  },
  {
    "id": 308,
    "topic_id": 200,
    "title": "Identify applications of active/active and active/passive configurations.",
    "description": "These include switch clusters, VRRP and HSRP, and firewall clusters."
  },
  {
    "id": 309,
    "topic_id": 200,
    "title": "Know and understand the various type of cloud services.",
    "description": "Software as a service (SaaS) allows us to use an application provided and maintained by the service provider. Platform as a service (PaaS) is a platform for designing applications that are compiled and executed in the cloud. Infrastructure as a service (IaaS) allows the customer to rent the infrastructure of compute, network, and storage from the cloud provider."
  },
  {
    "id": 310,
    "topic_id": 200,
    "title": "Know and understand the various cloud delivery models.",
    "description": "In a private cloud, resources are owned by the organization and exclusively used by the organization. In a public cloud, resources at the provider are provisioned and used by the general public. A hybrid model is a blend of both the public cloud and private cloud within an organization."
  },
  {
    "id": 311,
    "topic_id": 200,
    "title": "Understand the basic operations of infrastructure as code (IaC).",
    "description": "Infrastructure as code allows an administrator to provision servers with code-based automation and orchestration tools, in lieu of manual provisioning. IaC is performed through the methods of automation and source control."
  },
  {
    "id": 312,
    "topic_id": 200,
    "title": "Know the basic concepts of software-defined networking.",
    "description": "SDN controllers are centralized management plane systems that use application programming interfaces (APIs) to configure the data network as a whole, which eliminates the need to log in and make changes individually to a large number of individual networking devices. Infrastructure as code allows you to divide your infrastructure into modular components that can be combined in different ways using automation."
  },
  {
    "id": 313,
    "topic_id": 200,
    "title": "Know the seven troubleshooting steps, in order.",
    "description": "The steps, in order, are as follows:."
  },
  {
    "id": 314,
    "topic_id": 200,
    "title": "Be able to identify a link light.",
    "description": "A link light is the small, usually green LED on the back of a network card. This LED is typically found next to the media connector on a NIC and is usually labeled Link."
  },
  {
    "id": 315,
    "topic_id": 200,
    "title": "Understand how proper network use procedures can affect the operation of a network.",
    "description": "If a user is not following a network use procedure properly (for example, not logging in correctly), that user may report a problem where none exists. A good network troubleshooter should know how to differentiate between a network hardware/software problem and a \u201clack of user training\u201d problem."
  },
  {
    "id": 316,
    "topic_id": 200,
    "title": "Know how to narrow down a problem to one specific area or cause.",
    "description": "Most problems can be traced to one specific area or cause. You must be able to determine if a problem is specific to one user or a bunch of users, specific to one computer or a bunch of computers, and related to hardware or software. The answers to these questions will give you a very specific problem focus."
  },
  {
    "id": 317,
    "topic_id": 200,
    "title": "Know how to detect cabling-related problems.",
    "description": "Generally speaking, most cabling-related problems can be traced by plugging the suspect workstation into a known, working network port. If the problem disappears (or at the very least changes significantly), it is related to the cabling for that workstation."
  },
  {
    "id": 318,
    "topic_id": 200,
    "title": "Describe some of the GUI tools available to assist in testing and troubleshooting.",
    "description": "These include protocol analyzers, bandwidth speed testers, and connectivity software. Understand each product\u2019s purpose and how to use it."
  },
  {
    "id": 319,
    "topic_id": 200,
    "title": "Know how to describe and use the troubleshooting information and statistics that arp and netstat provide for you.",
    "description": "The arp utility shows whether an IP address is being resolved to your MAC address (or someone else\u2019s, in case of conflicts). The netstat utility produces TCP/IP statistics."
  },
  {
    "id": 320,
    "topic_id": 200,
    "title": "Know how to diagnose a network by using TCP/IP\u2019s troubleshooting commands.",
    "description": "The ping command echoes back if a machine is alive and active on a network. The tracert command shows the path that the ping packets take from source to target. And telnet enables a user to participate in a remote text-based session."
  },
  {
    "id": 321,
    "topic_id": 200,
    "title": "Know what the tracert utility does.",
    "description": "The tracert utility finds the route from your computer to any computer on a network."
  },
  {
    "id": 322,
    "topic_id": 200,
    "title": "Know what the ping utility does.",
    "description": "The ping utility determines whether a particular IP host is responding."
  },
  {
    "id": 323,
    "topic_id": 200,
    "title": "Know what the ftp utility does.",
    "description": "The ftp utility allows you to reliably download and upload files from and to an FTP server across the Internet."
  },
  {
    "id": 324,
    "topic_id": 200,
    "title": "Know what the ipconfig and ifconfig utilities do.",
    "description": "The ipconfig utility displays TCP/IP configuration information for Windows NT and later operating systems. The ifconfig utility performs a similar function in Linux/UNIX environments, in addition to performing certain interface-configuration tasks."
  },
  {
    "id": 325,
    "topic_id": 200,
    "title": "Know what the nslookup and dig utilities do.",
    "description": "The nslookup and dig utilities allow you to look up DNS resolution information."
  },
  {
    "id": 326,
    "topic_id": 200,
    "title": "Identify nmap and tcpdump.",
    "description": "While tcpdump is a command-line packet capture utility for Linux, nmap is a network reconnaissance tool that can identify live hosts, open ports, and the operating systems of devices."
  },
  {
    "id": 327,
    "topic_id": 200,
    "title": "Describe the use of the iptables utility.",
    "description": "iptables is a firewall utility built for the Linux operating system. It is a command-line utility that uses what are called chains to allow or disallow traffic. When traffic arrives, iptables looks for a rule that addresses that traffic type, and if none exists, it will enforce the default rule."
  },
  {
    "id": 328,
    "topic_id": 200,
    "title": "Understand what network scanners are and how to use each one.",
    "description": "Packet sniffers, IDS/IPS software, and port scanners are all network scanners. These devices can help you both troubleshoot and fix your network as well as find and stop hackers in their tracks."
  },
  {
    "id": 329,
    "topic_id": 200,
    "title": "Remember the basic purpose of a packet sniffer.",
    "description": "The basic purpose of packet sniffers or network analyzers is to collect and analyze each individual packet that is captured on a specific network segment to determine if problems are happening."
  },
  {
    "id": 330,
    "topic_id": 200,
    "title": "Know the CIA triad and how it applies to information security.",
    "description": "The CIA triad consists of the three concepts of confidentiality, integrity, and availability. Confidentiality defines how data is secured. Integrity defines how data is protected from unauthorized altering. Availability defines how data in systems is kept available to users and outages are avoided."
  },
  {
    "id": 331,
    "topic_id": 200,
    "title": "Understand the various security concepts.",
    "description": "A threat can be internal or external to your organization. A threat is the opportunity for a security event. Risk is the potential that a threat can occur. A vulnerability is a weakness in security. The Common, Vulnerabilities, and Exposures (CVE) is a standardized cataloging system for vulnerabilities across all vendors. Exploits are code or techniques that can be carried out upon a vulnerability."
  },
  {
    "id": 332,
    "topic_id": 200,
    "title": "Know the two basic types of encryptions.",
    "description": "Symmetric encryption uses the same key as used to decrypt the information. Asymmetrical encryption uses a key pair: One key is used to encrypt, and the other is used to decrypt."
  },
  {
    "id": 333,
    "topic_id": 200,
    "title": "Understand how PKI is used to protect information.",
    "description": "PKI uses asymmetrical key encryption to protect information by signing documents for integrity. PKI can also be used to encrypt documents for the purpose of confidentiality."
  },
  {
    "id": 334,
    "topic_id": 200,
    "title": "Identify common authentication methods.",
    "description": "These include multifactor methods, Terminal Access Controller Access-Control System Plus (TACACS+), single sign-on (SSO), Remote Authentication Dial-In User Service (RADIUS), and LDAP."
  },
  {
    "id": 335,
    "topic_id": 200,
    "title": "Understand the various authorization concepts.",
    "description": "Identity and access management (IAM) is a security framework. The principle of least privilege defines that an employee is given only the access required to perform their duties. Role-based access is the technique of combining privileges together for common roles in an organization."
  },
  {
    "id": 336,
    "topic_id": 200,
    "title": "Explain common technology-based attacks.",
    "description": "These include denial-of-service (DoS)/distributed denial-of-service (DDoS) attacks, on-path attacks, DNS poisoning, VLAN hopping, ARP spoofing, rogue DHCP and rogue access point (AP) attacks, evil twin attacks, ransomware, and password attacks."
  },
  {
    "id": 337,
    "topic_id": 200,
    "title": "Identify human and environmental attacks.",
    "description": "These include social engineering, phishing, tailgating, piggybacking, and shoulder surfing."
  },
  {
    "id": 338,
    "topic_id": 200,
    "title": "Understand the various methods of hardening network systems.",
    "description": "Changing default credentials for network systems will thwart brute-force attacks against default usernames. Disabling unused services on a network system reduces the area of attack by reducing the number of services that are potentially vulnerable. Access control lists (ACLs) consist of conditions and actions to control traffic for applications."
  },
  {
    "id": 339,
    "topic_id": 200,
    "title": "Know the various techniques of implementing network segmentations.",
    "description": "Screened subnets, 802.1X, NAC, and port security are just a few of the many tactics used for network segmentation covered in this chapter. You should review the various techniques listed in this chapter."
  },
  {
    "id": 340,
    "topic_id": 200,
    "title": "Know the various tactics used for physical security.",
    "description": "Video surveillance can be deployed as a coaxial network called closed-circuit television (CCTV) or Ethernet. Using locks prevent equipment from being affected by malicious intent, mistakenly being affected, or stolen. Locking doors and cabinets safeguards against snooping employees or attackers looking for files or equipment."
  }
];
